import UserAvatarUploadButton from './UserAvatarUploadButton';

export default UserAvatarUploadButton;
